import { Descendant } from "slate"
import { FacebookTemplateModel } from "../../../models/templates.models";

export type MentionElement = {
    type: 'mention' | 'link' | 'mail';
    character: string;
    length: number;
    children: CustomText[];
    className: string;
}

export type CustomText = {
    bold?: boolean
    italic?: boolean
    code?: boolean
    text: string
}

export interface IMentionProps {
    body: string;
    emoji: string;
    openTags: boolean;
    isTemplate?: boolean;
    tagTarget: HTMLButtonElement | null;
    onChange: (event: any, length: number) => void;
    onKeyDown: (event: any) => void;
    onBlur?: (event: any) => void;
    closeTags: (event?: any) => void;
    tags:
    { catagory: string; label: string; tags: { id: string; display: string; length: number; className: string; }[]; }[];
    // tags: ;
    maxLength: number;
    id: string;
    sign?: string;
    bodyWithSignature?: string;
    placeholder: string;
    height?: number;
    IsMobileDevice?: boolean;
    deviceHeight?: number;
    readOnly?: boolean;
    lineHeight?: number;
    IsNewMessage?: boolean;
    IsOutbound?: boolean;
    IsLinkAllowed?: boolean;
    IsAddRule?: boolean;
    IsGroupChat?: boolean;
    phoneNumbers?: string[];
    FacebookTemplate?: FacebookTemplateModel;
    RemoveFacebookTemplate?: () => void;
    Media?: any;
    Focus?:boolean;
}


export const mapTextToDescendants = (text: string, tags: { id: string; display: string; length: number; className: string; }[], IsLinkAllowed: boolean): Descendant[] => {
    let result: Descendant[] = [];

    let lines = text.split(/\n|\r\n/);
    lines.forEach(line => {
        let children: Descendant[] = [];
        let delimiter = "!@#$%^&*()";
        while (line.includes(delimiter)) {
            delimiter = delimiter + "!@#$%^&*()";
        }

        let segments = line.replace(/\{{_/g, `${delimiter}{{_`).replace(/\_}}/g, `_}}${delimiter}`)
            .split(delimiter);

        segments.forEach(segment => {
            let regex = /(?:\{{_)\w+(?=\_}})/g;
            let link = /(?:(?:https?|ftp):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/gim;
            let mail = /(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;


            if (regex.test(segment)) {
                let matches = segment.match(regex);
                children.push({
                    type: 'mention',
                    character: matches ? matches[0].replace(/\{{_/g, "") : "",
                    children: [{ text: '' }],
                    length: tags.find(x => x.id === matches[0].replace(/\{{_/g, ""))?.length || 0,
                    className: tags.find(x => x.id === matches[0].replace(/\{{_/g, ""))?.className
                } as any)
            }
            else if ((link.test(segment) || mail.test(segment)) && IsLinkAllowed) {
                segment.split(" ").forEach(x => {
                    let linkMatchRegEx = /^(?:(?:https?|ftp):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])$/gim;
                    let linkMatch = x.match(linkMatchRegEx);
                    let mailMatch = x.match(mail);
                    if (linkMatch) {
                        children.push({
                            type: 'link',
                            character: x.toString() + " ",
                            children: [{ text: '' }],
                            length: linkMatch.length
                        } as any)
                    }
                    else if (mailMatch) {
                        children.push({
                            type: 'mail',
                            character: x.toString() + " ",
                            children: [{ text: '' }],
                            length: mailMatch.length
                        } as any)
                    }
                    else {
                        children.push({
                            text: x + " "
                        })
                    }
                })
            }
            else {
                children.push({
                    text: segment
                })
            }
        });

        result.push({
            type: 'paragraph',
            children
        } as any)
    });
    return result;
}


export const mapDescendantsToText = (descendants: Descendant[]): string => {

    let transformedText = descendants
        .map((x: any) =>
            !!x.type ? x.type === "mention" ?
                ({ text: `{{_${x.character.trim().replace(/ /g, "")}_}}`, postfix: "" })
                : x.type === 'link' ? ({ text: x.character, postfix: "" })
                    : x.type === 'mail' ? ({ text: x.character, postfix: "" })
                        : ({ text: mapDescendantsToText(x.children), postfix: "\n" })
                : ({ text: x.text, postfix: "" }));
    return transformedText.reduce((result: string, current: { text: string, postfix: string }, index: number) => `${result}${current.text}${index === transformedText.length - 1 ? "" : current.postfix}`, "");
}


export const computeLength = (descendants: Descendant[]): number => descendants.reduce((sum: number, x: any) => sum + (!!x.type ? x.type === "mention" ? x.length : computeLength(x.children) : x.text.length), (descendants.length - 1) * 2);